module.exports = __webpack_public_path__ + "img/pic_4.4407f759.png";